import { paymentRequirementsCreateSignMappedKeys } from '@/feature/PaymentRequirements/models/payment-requirements-sign-mapped-keys';
import ObjectUtils from '@/modules/Object/ObjectUtils';
import { Component, Vue } from 'vue-property-decorator';
import { PaymentRequirementsItem, PaymentRequirementsItemCreationSignData, PaymentRequirementsItemSignData } from '../../../api/incoming/payment-requirements-incoming.interface';

@Component
export default class PaymentRequirementsIncomingSignMapper extends Vue {

	checkPaymentRequirementsItemValueIsFullZero(
		value?: string | null
	): boolean {
		value = value || '';

		return value === '0'.repeat(value.length);
	}

	getPaymentRequirementsItemValueWithoutFullZero(
		value?: string | null
	): string | null {
		return !value
			|| this.checkPaymentRequirementsItemValueIsFullZero(value)
			? null
			: value;
	}

	mapPaymentRequirementsItemForSign(
		paymentRequirements: PaymentRequirementsItem
	): PaymentRequirementsItemSignData {
		return {
			documentNumber: paymentRequirements.documentNumber,
			documentDate: paymentRequirements.documentDate,
			requesterName: paymentRequirements.requesterName,
			requesterAccountNumber: paymentRequirements.requesterAccountNumber,
			requesterMfo: paymentRequirements.requesterMfo,
			requesterInn: this.getPaymentRequirementsItemValueWithoutFullZero(
				paymentRequirements.requesterInn
			),
			requesterPinfl: this.getPaymentRequirementsItemValueWithoutFullZero(
				paymentRequirements.requesterPinfl
			),
			debitAccountNumber: paymentRequirements.debitAccountNumber,
			debitMfo: paymentRequirements.debitMfo,
			debitName: paymentRequirements.debitName,
			debitInn: this.getPaymentRequirementsItemValueWithoutFullZero(
				paymentRequirements.debitInn
			),
			debitPinfl: this.getPaymentRequirementsItemValueWithoutFullZero(
				paymentRequirements.debitPinfl
			),
			paymentType: paymentRequirements.paymentType,
			paymentTypeName: paymentRequirements.paymentTypeName,
			purposeCode: paymentRequirements.purposeCode,
			purposeCodeName: paymentRequirements.purposeCodeName,
			unpaid: paymentRequirements.unpaid,
			unpaidName: paymentRequirements.unpaidName,
			amount: paymentRequirements.amount || 0,
			purpose: paymentRequirements.purpose,
			paymentRequirementId: paymentRequirements.paymentRequirementId,
		};
	}

	mapPaymentRequirementsItemForCreationSign(
		paymentRequirements: PaymentRequirementsItem
	): PaymentRequirementsItemCreationSignData {
		return Object.assign(
			ObjectUtils.includeKeys(
				this.mapPaymentRequirementsItemForSign(
					paymentRequirements
				),
				paymentRequirementsCreateSignMappedKeys
			),
			{
				debitMfoName: paymentRequirements.debitMfoName,
				requesterMfoName: paymentRequirements.requesterMfoName,
			}
		);
	}

}